//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const getOpts = (opts, selected) => {
    return Object.keys(opts).reduce((prev, level) => {
        prev[level] = opts[level].map((opt) => {
            return {
                id: opt.id,
                name: opt.name,
                selected: selected.indexOf(opt.id) > -1
            }
        })
        return prev
    }, {})
}
export default {
    props: {
        is_large: {
            type: Boolean,
            default: false
        },
        selected: {
            type: Array
        },
        zones: {
            type: [Object, null]
        }
    },
    data () {
        return {
            levels: [
                {
                    key: 'level1',
                    name: '一圈层（中心城区）'
                },
                {
                    key: 'level2',
                    name: '二圈层（近郊）'
                },
                {
                    key: 'level3',
                    name: '三圈层（远郊）'
                },
                {
                    key: 'others',
                    name: '更多'
                }
            ],
            inner_selected: this.selected,
            opts: getOpts(this.zones, this.selected)
        }
    },
    created () {
        this.$watch(function () {
            return {
                zones: this.zones,
                selected: this.selected
            }
        }, function({ zones, selected }, oldVal) {
            if (zones != oldVal.zones || selected != oldVal.selected) {
                this.inner_selected = selected
                this.opts = getOpts(zones, selected)
            }
        })
    },
    destroyed () {
        this.inner_selected = []
    },
    computed: {
        all_selected () {
            return {
                level1: this.getSelected('level1'),
                level2:  this.getSelected('level2'),
                level3:  this.getSelected('level3'),
                others:  this.getSelected('others')
            }
        }
    },
    methods: {
        getSelected (level) {
            return this.opts && this.opts[level] ? this.opts[level].every(zone => zone.selected) : false
        },
        onSelectAll (level) {
            const levelZone = this.opts[level]
            if (levelZone) {
                const { inner_selected } = this
                const selectedAll = levelZone.some(zone => !zone.selected)
                this.opts[level] = levelZone.map(zone => {
                    const index = inner_selected.indexOf(zone.id)
                    if (index > -1 && !selectedAll) {
                        this.$delete(this.inner_selected, index)
                    } else if (index === -1) {
                        inner_selected.push(zone.id)
                    }
                    return {
                        ...zone,
                        selected: selectedAll
                    }
                })
            }
            this.change()
        },
        onSelect (value, key, i) {
            const { inner_selected } = this
            const index = inner_selected.indexOf(value)
            if (index === -1) {
                inner_selected.push(value)
            } else {
                this.$delete(this.inner_selected, index)
            }
            this.inner_selected = inner_selected.map(i => i)
            this.opts = getOpts(this.zones, inner_selected)
            this.change()
        },
        change () {
            let select_tx = []
            const all_selected = Object.keys(this.all_selected).some((key, i) => {
                if (this.all_selected[key]) {
                    select_tx = [this.levels[i].name]
                    return true
                }
            })
            if (!all_selected) {
                select_tx = Object.keys(this.opts).reduce((text, key) => {
                    if (this.opts[key] && this.opts[key].length) {
                        const new_text = this.opts[key]
                            .filter(({ selected }) => selected)
                            .map(({ name }) => name)
                        text.push(...new_text)
                    }
                    return text
                }, [])
            }
            this.$emit('change', this.inner_selected, select_tx)
        }
    }
}
